import { render } from "./AiAssistant.vue?vue&type=template&id=1daa1d39&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=1daa1d39&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1daa1d39"]])

export default __exports__